import { IEdTabsMenu } from '@/content/interfaces/ed-tabs-menu.interface';
import { IParamsCreateCourseMaterialObject } from '@/courses/interfaces/params-create-course-material-object.interface';
import { IParamsFileToWriteObject } from '@/courses/interfaces/params-file-to-write-object.interface';
import { IResultFileToWriteObject } from '@/courses/interfaces/result-file-to-write-objecct.interface';
import { COURSE_MATERIAL_KEYS, FILE_TO_WRITE_OBJECT } from '@/courses/values/courses.values';
import Component from 'vue-class-component';
import { Prop , Mixins, Emit} from 'vue-property-decorator';
import EdCreateCourseMaterialObject from '@/courses/components/course-material-object/ed-create-course-material-object/ed-create-course-material-object.vue';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { CourseCreateSplitObjectMixin } from '@/courses/mixins/course-create-split-object.mixin'
import Course from '@/content/models/course.model';
import ToolService from '@/providers/tools';

@Component({
  components: {
    EdCreateCourseMaterialObject
  }
})
export default class EdFileToSplitObject extends Mixins(CourseCreateSplitObjectMixin) {

  @Prop() readonly params: IParamsFileToWriteObject; 
  @Prop() readonly product: any; 
  @Prop() readonly currentData: any; 

  public result: IResultFileToWriteObject = { type: FILE_TO_WRITE_OBJECT.FILE };
  public menu: IEdTabsMenu[] = [];
  public file: any = null;
  public tabsId = {
    file: 'FileTab',
    courseMaterial: 'CourseMaterialTab',
  };
  public dropOptions: any = {
    url: 'http://eduac/upload',
    autoProcessQueue: false,
    acceptedFiles: 'application/pdf',
    addRemoveLinks: true,
    uploadMultiple: false,
    maxFiles: 1,
    maxFilesize: 100,
    parallelUploads: 1,
    createImageThumbnails: false,
    timeout: 600000
  }
  public cmoParams: IParamsCreateCourseMaterialObject;
  public canShowRotation: boolean = false;

  @Emit('onRotateModal')
  onRotateModal(value) {
    return value;
  }

  get edition(): boolean {
    return this.params.edition;
  }

  get hasFile() {
    return this.file ? true : false;
  }

  get fileName() {
    return this.hasFile ? ToolService.exitSpecialChars(this.file.name) : '';
  }

  get disclamer(): string {
    return this.params.disclamer;
  }

  get name(): string {
    return this.params.name;
  }

  get hasMaterials(): boolean {
    let filterMaterials = JSON.parse(JSON.stringify(this.product.materials));
    return SectionsProvider.checkCourseMaterials(filterMaterials);
  }

  onTabChanged(tabChanged: IEdTabsMenu) {
    if(tabChanged.contentId == this.tabsId.file) {
      this.result.type = FILE_TO_WRITE_OBJECT.FILE;
    } else {
      this.result.type = FILE_TO_WRITE_OBJECT.COURSE_MATERIAL;
    }
    this.$emit('onChange', this.result);
  }

  setMenu(selected: string) {
    this.menu = [{
      name: String(this.$i18n.t('courses.writeObject.fileTab')),
      contentId: this.tabsId.file,
      active: selected == FILE_TO_WRITE_OBJECT.FILE,
      visible: true
    }, {
      name: String(this.$i18n.t('courses.writeObject.courseMaterialTab')),
      contentId: this.tabsId.courseMaterial,
      active: selected == FILE_TO_WRITE_OBJECT.COURSE_MATERIAL,
      visible: true,
      disabled: !this.hasMaterials
    }]
  }

  onFileAdded(file: any) {
    setTimeout(() => {
      if(file.accepted) {
        this.file = file;
        this.updateSelected();
      }
    }, 0);
  }

  removeFile() {
    this.file = null;
    this.canShowRotation = false;
    this.updateSelected();
  }

  updateSelected() {
    this.result.file = this.file;
    this.$emit('onChange', this.result);
  }

  onChangedCourseMaterial(cmo: any) {
    if(cmo.material) {
      cmo.name = cmo.material.data.title;
      cmo.isMultimediaFile = this.isMultimediaFile(cmo.material.data.mimeType);
      cmo.displayType = cmo.isMultimediaFile ? COURSE_MATERIAL_KEYS.CONTINUE : cmo.displayType;
      this.result.cmo = cmo;
    } else {
      this.result.cmo = null;
    }
    this.$emit('onChange', this.result);
  }

  setEditionData() {
    let currentMaterial = this.getCurrentMaterial();
    let start = currentMaterial ? decodeURIComponent(this.params.cmo.sectionMaterial.startSection) : '';
    let end = currentMaterial ? decodeURIComponent(this.params.cmo.sectionMaterial.endSection) : '';
    this.file = this.params.file;
    this.result = {
      type: this.params.selected,
      file: this.file
    };
    this.cmoParams = {
      hasName: false,
      hasButtons: false,
      hasTitle: false,
      edition: currentMaterial ? true : false,
      currentMaterial,
      onlyDisplayType: COURSE_MATERIAL_KEYS.SPLICE,
      start,
      end,
      displayType: COURSE_MATERIAL_KEYS.SPLICE,
      labelSections: '',
    };
  }

  getCurrentMaterial() {
    if(this.params.cmo) {
      return SectionsProvider.findCurrentCourseMaterial(
        this.product.materials,
        this.params.cmo.sectionMaterial.materialId
      );
    } else {
      return null;
    }
  }

  rotateModal() {
    this.onRotateModal(true);
  }

  created() {
    this.setMenu(this.edition ? this.params.selected : FILE_TO_WRITE_OBJECT.FILE);
    if(this.edition) {
      if(this.params?.file) {
        this.canShowRotation = true;
      }
      this.setEditionData();
    } else {
      this.canShowRotation = false;
      this.cmoParams = {
        hasName: false,
        hasButtons: false,
        hasTitle: false,
        edition: false,
        currentMaterial: null,
        onlyDisplayType: COURSE_MATERIAL_KEYS.SPLICE,
        labelSections: '',
      };
      this.file = null;
      this.result = { type: FILE_TO_WRITE_OBJECT.FILE, file: null };
    } 
  }


}